export default __webpack_public_path__ + "static/media/logo.6da76eb6.png";